"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var SwiperWithDots_1 = require("../../../ezUI/SwiperWithDots");
var Image_1 = require("../../../components/Image");
var link_1 = require("../../../utils/link");
var url_1 = require("../../../../utils/url");
var mutil_Language_1 = require("../../../utils/mutil-Language");
var WithEZSpm_1 = require("../../../../components/WithEZSpm");
var s = require("./index.scss");
var TopSwiper = (function (_super) {
    __extends(TopSwiper, _super);
    function TopSwiper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopSwiper.prototype.genTSpmLinkByUrl = function (link, order) {
        if (link) {
            var index = this.props.index;
            var url = url_1.genPrmLink(link, { floor: index, position: order });
            return url;
        }
    };
    TopSwiper.prototype.linkTo = function (banner, i) {
        var link = mutil_Language_1.multilingualLinkDisplay(banner);
        this.genTSpmLinkByUrl(link, i + 1);
        if (link) {
            link_1.clickJump(link);
        }
    };
    TopSwiper.prototype.render = function () {
        var _this = this;
        var _a = this.props, moduleDetail = _a.moduleDetail, commonProps = _a.commonProps, addModuleMap = _a.addModuleMap, index = _a.index;
        var module, elements;
        if (moduleDetail) {
            module = moduleDetail.module;
            elements = module.elements;
        }
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } },
            React.createElement(React.Fragment, null, moduleDetail ? (React.createElement("div", { className: s.swiperWrap },
                React.createElement(SwiperWithDots_1.default, { style: {
                        width: "100%",
                        height: "9.375rem",
                        overflow: "hidden"
                    } }, elements.map(function (item, i) { return (React.createElement("div", { key: i, onClick: function () { return _this.linkTo(item.items[0], i); } },
                    React.createElement(Image_1.default, { src: smartimagesrc_1.makeImageUrls(mutil_Language_1.multilingualImgDisplay(item.items[0]), {
                            online: true,
                            qnParams: { w: 750 },
                            keepSize: true,
                            aliSize: 2
                        })[0] || item.items[0].img, useOriginSrc: true, style: {
                            display: "block",
                            width: "100vw",
                            height: "9.375rem"
                        }, alisize: 2, isLazyLoad: true }))); })))) : null)));
    };
    return TopSwiper;
}(React.Component));
exports.default = WithEZSpm_1.default(TopSwiper);
